import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import API from "../../services/api.jsx";
import Loader from "../layout/loader.jsx";
import { toast } from "react-toastify";
import Helpers from "../../services/helpers.jsx";
import DB from '../../services/db.jsx';

class UserEdit extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      loading: true,
      breadcrumb: {
        title: 'back to Users',
        path: '/users/list',
      },
      fields: {
        name: { label: 'User name', type: 'text', required: true },
        email: { label: 'Email address', type: 'email', required: true },
        role: {
          label: 'Role',
          type: 'select',
          required: true,
          disabled: Helpers.isSuperAdmin() ? false : true,
          options: [],
        },
        disabled: {
          label: 'Account status',
          type: 'select',
          hidden:
            Helpers.isSuperAdmin() || Helpers.isAffiliateAdmin() ? false : true,
          required: true,
          options: [
            { key: 'true', label: 'Disabled' },
            { key: 'false', label: 'Active' },
          ],
        },
        affiliates: {
          label: 'Assigned affiliate(s)',
          type: 'select-multi',
          optionKey: 'affiliates',
          fullWidth: true,
          required: false,
          disabled: Helpers.isSuperAdmin() ? false : true,
          options: [],
          hidden:
            (Helpers.isSuperAdmin() || Helpers.checkPermissions('users:edit')
              ? false
              : true) || DB.get('user').affiliates.length === 1,
        },
        clients: {
          label: 'Add extra client(s) - Optional',
          type: 'select-multi',
          optionKey: 'clients',
          fullWidth: true,
          required: false,
          options: [],
          hidden: !Helpers.checkPermissions(['clients:edit', 'clients:delete'], true),
          tooltip: `Assign client access to this user
          Use this field to give the user access to a specific client, if they don’t already have access by default.
					Please note:
					- Account Managers only see the clients they’ve created unless assigned more.
					- Affiliate Admins and Managers already have access to all Affiliate clients.
					`,
        },
      },
      user: null,
    };
    this.afterChange = this.afterChange.bind(this);
    this.saveEntity = this.saveEntity.bind(this);
    this.deleteEntity = this.deleteEntity.bind(this);
  }

  componentDidMount() {
    this.loadUser();
    this.loadRoleOptions();
  }

  loadUser() {
    API.getUser(this.props.match.params.userId).then((user) => {
      this.setState(prevState => {
        return {
          loading: false,
          user: {
            ...user,
            role: user.role.id,
            disabled: user.disabled.toString(),
            affiliates: user.affiliates.map((affiliate) => affiliate.id),
            clients: user.clients.map((client) => client.id),
          },
          fields: {
            ...prevState.fields,
            disabled: {
              ...prevState.fields.disabled,
              disabled: Helpers.isSuperAdmin()
                ? false
                : !user.affiliates.every((affliate) =>
                    DB.get('user').affiliates.some(
                      (aff) => aff.id === affliate.id
                    )
                  ),
            },
            affiliates: {
              ...prevState.fields.affiliates,
              hidden: user.role.name === 'Client' ? true : false,
            },
          },
        };
      });
    });
  }

  loadRoleOptions() {
    API.getAvaliableOptions("roles").then((entities) => {
      const roles = entities?.roles?.map((role) => ({
        key: role.id,
        label: role.name,
      }));
      this.setState((prevState) => ({
        fields: {
          ...prevState.fields,
          role: { ...prevState.fields.role, options: roles },
        },
      }));
    });
  }

  afterChange(key, value) {
    if (key === "role") {
      const role = this.state.fields.role.options.find((option) => option.key === value);
      if (Helpers.isClient(role?.label)) {
          this.setState((prevState) => ({
            fields: {
              ...prevState.fields,
              affiliates: {
                ...prevState.fields.affiliates,
                hidden: true,
              },
              clients: {
                ...prevState.fields.clients,
                type: "select",
              },
            },
            entity: {
              ...prevState.entity,
              affiliates: null,
              clients: null,
            },
          }));
        } else {
          this.setState((prevState) => ({
            fields: {
              ...prevState.fields,
              affiliates: {
                ...prevState.fields.affiliates,
                hidden: false,
              },
              clients: {
                ...prevState.fields.clients,
                type: "select-multi",
              },
            },
          }));
        }
    }
  }

  saveEntity(fields) {
    if (!Helpers.checkPermissions("users:edit")) {
      toast.error("You do not have permission to save it");
      return;
    }

    const updatedFields = {
      ...fields,
      disabled: fields.disabled === "true",
    };

    this.setState({ loading: true });
    API.update("users", this.props.match.params.userId, updatedFields)
      .then(() => {
        toast.success("User has been updated");
        this.props.history.push("/users/list");
      })
      .catch(() => {
        // toast.error("An unexpected error has occurred, please try again");
        this.setState({ loading: false });
      });
  }

  deleteEntity() {
    var r = window.confirm("Are you sure you want to delete this user?");
    if (r === false) return;

    this.setState({ loading: true });
    API.delete("users", this.props.match.params.userId)
      .then(() => {
        toast.success("User has been deleted");
        this.props.history.push("/users/list");
      })
      .catch(() => {
        // toast.error("An unexpected error has occurred, please try again");
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head
            title={this.state.user?.name || 'Edit user'}
            breadcrumb={this.state.breadcrumb}
            tabs={this.state.tabs}
          />
          <Content>
            <Form
              fields={this.state.fields}
              entity={this.state.user}
              cancel={() => this.props.history.push('/users/list')}
              save={this.saveEntity}
              canDelete={Helpers.checkPermissions('users:delete')}
              hideCancel={!Helpers.checkPermissions('users:edit')}
              hideSave={!Helpers.checkPermissions('users:edit')}
              delete={this.deleteEntity}
              afterChange={this.afterChange}
              disabled={!Helpers.checkPermissions('users:edit')}
            />
          </Content>
        </>
      );
  }
}

export default UserEdit;
